import React from "react";

const UsersLoading = () => {
  return (
    <div className="space-y-6" aria-busy="true" role="status">
      {/* Loading Skeleton for Stats Cards */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, index) => (
          <div
            key={index}
            className="border-border bg-card animate-pulse rounded-lg border p-6 motion-reduce:animate-none"
          >
            <div className="flex items-center justify-between">
              <div className="space-y-2">
                <div className="bg-muted h-4 w-20 rounded"></div>
                <div className="bg-muted h-8 w-16 rounded"></div>
              </div>
              <div className="bg-muted h-12 w-12 rounded-md"></div>
            </div>
          </div>
        ))}
      </div>

      {/* Loading Skeleton for Tabs */}
      <div className="border-border border-b">
        <div className="flex space-x-8">
          {[...Array(3)].map((_, index) => (
            <div key={index} className="px-1 py-4">
              <div className="bg-muted h-4 w-24 animate-pulse rounded motion-reduce:animate-none"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Loading Skeleton for Search and Filters */}
      <div className="flex flex-col items-center justify-between gap-4 lg:flex-row">
        <div className="flex w-full flex-col gap-4 sm:flex-row lg:w-auto">
          <div className="bg-muted h-11 w-full max-w-80 animate-pulse rounded-sm motion-reduce:animate-none"></div>
          <div className="bg-muted h-11 w-full max-w-40 animate-pulse rounded-sm motion-reduce:animate-none"></div>
        </div>
      </div>

      {/* Loading Skeleton for User Cards */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(6)].map((_, index) => (
          <div
            key={index}
            className="border-border bg-card animate-pulse rounded-lg border p-6 motion-reduce:animate-none"
          >
            <div className="mb-4 flex items-start justify-between">
              <div className="flex items-center space-x-3">
                <div className="bg-muted h-12 w-12 rounded-full"></div>
                <div className="space-y-2">
                  <div className="bg-muted h-4 w-24 rounded"></div>
                  <div className="bg-muted h-3 w-16 rounded"></div>
                </div>
              </div>
              <div className="bg-muted h-6 w-16 rounded-full"></div>
            </div>

            <div className="mb-4 space-y-2">
              <div className="bg-muted h-3 w-32 rounded"></div>
              <div className="bg-muted h-3 w-40 rounded"></div>
            </div>

            <div className="mb-4 grid grid-cols-2 gap-4">
              <div className="space-y-2 text-center">
                <div className="bg-muted mx-auto h-3 w-16 rounded"></div>
                <div className="bg-muted mx-auto h-4 w-8 rounded"></div>
              </div>
              <div className="space-y-2 text-center">
                <div className="bg-muted mx-auto h-3 w-20 rounded"></div>
                <div className="bg-muted mx-auto h-4 w-12 rounded"></div>
              </div>
            </div>

            <div className="flex justify-end">
              <div className="bg-muted h-6 w-20 rounded-full"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UsersLoading;
